/* eslint-disable no-restricted-imports */
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import React from "react";
import LogoDrai from "src/assets/logo-drai.png";
import EsloganDrai from "src/assets/slogan-drai.png";
import packageJson from "../../../../package.json";

interface SidebarFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  collapsed?: boolean;
}

const StyledSidebarFooter = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 20px;
  color: #93A0E9;
  border: 3px solid;
  background: transparent;
`;

const StyledCollapsedSidebarFooter = styled.a`
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: default;
  border: 3px solid;
  color: transparent;
  border-radius: 100px;
  background: transparent;
`;

export const SidebarFooter: React.FC<SidebarFooterProps> = ({
  children,
  collapsed,
  ...rest
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingBottom: "20px",
      }}
    >
      {collapsed ? (
        <StyledCollapsedSidebarFooter target="_blank">
          <img src={LogoDrai} alt="Logo DRAI" width="100%" />
        </StyledCollapsedSidebarFooter>
      ) : (
        <StyledSidebarFooter {...rest}>
          <div
            style={{
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img src={LogoDrai} alt="Logo DRAI" width="30px" />
            <img src={EsloganDrai} alt="Eslogan DRAI" height="20px" />
          </div>
          <Typography
            variant="caption"
            style={{ letterSpacing: 1, color: "black" }}
          >
            V {packageJson.version}
          </Typography>
        </StyledSidebarFooter>
      )}
    </div>
  );
};
